import React from 'react';

import { useSelector } from 'react-redux';
import * as ShopSelectors from 'selectors/ShopSelectors';
import * as UserSelectors from 'selectors/UserSelectors';
import { useTranslation } from 'services/localization/useTranslation';
import ExternalLinkButton from 'common/components/ExternalLinkButton';
import { logEvent } from 'common/services/analytics';

const ViewStoreBtn = () => {
	const shopStoreUrl = useSelector(ShopSelectors.activeShopOnlineURL);
	const shopPlan = useSelector(ShopSelectors.shopPlan);
	const mainlocation = useSelector(ShopSelectors.activeShopMainLocationId);
	const activeLocation = useSelector(ShopSelectors.activeShopLocationUrlsById);
	const userLocation = useSelector(UserSelectors.userActiveLocationId)!;
	const locationName = activeLocation[userLocation];
	const { t } = useTranslation();

	const handleOnlineStoreButtonEvent = () => {
		logEvent('view_online_store_button_click', { plan: shopPlan });
	};

	return (
		<ExternalLinkButton
			href={
				userLocation === mainlocation
					? `${shopStoreUrl}/shop?admin=true`
					: `${shopStoreUrl}/l/${locationName}?admin=true`
			}
			text={t('headerBar.viewStore', 'View online store')}
			onClick={handleOnlineStoreButtonEvent}
		/>
	);
};

export default ViewStoreBtn;
